// extracted by mini-css-extract-plugin
export default {"container":"style_container__QUCY4","card":"style_card__qjTir","row":"style_row__S2PPR","btnsRow":"style_btnsRow__GqjP0"};